import React from 'react';
import {connect} from 'react-redux';
import {endUnpublishChallengeAction, submitUnpublishChallengeAction} from "./actions";
import BasicModal from "components/common/BasicModal";
import {FormattedMessage} from "react-intl";
import {platformCircledLetterClasses} from "utils/DBUtils";
import {isNoU} from "../../utils/DBUtils";

const VerifyPublishChallengeModal = (props) => (
    <BasicModal header={<FormattedMessage id='modal.verify.unpublish.header'/>}
                open={props.modalOpen}
                onClose={props.handleClose}
                actions={[
                    {
                        label: "Cancel",
                        action: props.handleClose,
                        disabled: props.unpublishingChallengePending,
                        displayType: "menu-item"
                    },
                    {
                        label: "Unpublish",
                        action: props.submit,
                        loading: props.unpublishingChallengePending,
                        displayType: "button",
                        primaryCheck: true
                    }
                ]}>
        <div>
            <FormattedMessage id='modal.verify.unpublish.content'/> {props.breakUrl}
            {props.breakPlatform.map((platform) => (
                platform !== "MASTER" ?
                    <div className={`circled-letter ${platformCircledLetterClasses[platform] || ''}`}> </div>: ""
            ))}
        </div>
    </BasicModal>
);

const mapStateToProps = (state) => {
    let challenge = state.publishChallenge.challengeBeingUnpublished;
    let actualPlatforms = [];

    if (!isNoU(challenge)) {
        let challengePlatforms = Object.keys(challenge.breaks || {});
        let unpublishPlatforms = state.publishChallenge.platformsBeingUnpublished || [];
        for (let platform of unpublishPlatforms) {
            if (challengePlatforms.indexOf(platform) > -1) {
                actualPlatforms.push(platform);
            }
        }
    }

    return {
        modalOpen: state.publishChallenge.unpublishingChallenge,
        breakUrl: state.publishChallenge.unpublishingChallengeBreak ? state.publishChallenge.unpublishingChallengeBreak.permalink : "",
        breakPlatform: actualPlatforms
    };
};

const mapDispatchToProps = (dispatch) => ({
    submit: () => dispatch(submitUnpublishChallengeAction()),
    handleClose: () => dispatch(endUnpublishChallengeAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyPublishChallengeModal);


// WEBPACK FOOTER //
// ./public/pages/BreakPublish/VerifyUnpublishChallengeModal.jsx